import { displayBasicNotification } from '#/components/layout/notifications/notificationsUtils';
import { joinWordsWithAndAtTheEnd } from '#/lib/string';
import { UnreachableCaseError, filterFalsy } from '#/lib/utils';

import { IAction, PanelState } from './buyPanelReducer';
import { BuySellPanelCalculatedInfo } from './buySellInfo';

export function validateTPSLOrThrow({
  panelState,
  calculatedInfo,
}: {
  panelState: Pick<
    PanelState,
    | 'price'
    | 'triggerPrice'
    | 'triggerEnabled'
    | 'orderType'
    | 'sizeInQuote'
    | 'sizePercentage'
    | 'size'
  >;
  calculatedInfo: Pick<
    BuySellPanelCalculatedInfo,
    'quantityBuy' | 'quantitySell'
  >;
}) {
  const quantity =
    !panelState.sizeInQuote && !panelState.sizePercentage
      ? panelState.size
      : Number(calculatedInfo.quantityBuy || 0) || calculatedInfo.quantitySell;
  const checks = {
    price: !!Number(panelState.price),
    'trigger price': !!Number(panelState.triggerPrice),
    quantity: !!Number(quantity || 0),
  };
  const textValidated = (keys: (keyof typeof checks)[]) => {
    const errors = keys
      .map(key => (checks[key] ? false : key))
      .filter(filterFalsy);
    return errors.length === 0
      ? false
      : `Please enter order ${joinWordsWithAndAtTheEnd(errors)}`;
  };

  let errorText: string | false;

  switch (panelState.orderType) {
    case 'limit':
      if (panelState.triggerEnabled) {
        errorText = textValidated(['price', 'trigger price', 'quantity']);
      } else {
        errorText = textValidated(['price', 'quantity']);
      }
      break;
    case 'market':
      if (panelState.triggerEnabled) {
        errorText = textValidated(['trigger price', 'quantity']);
      } else {
        errorText = textValidated(['quantity']);
      }
      break;
    default:
      throw new UnreachableCaseError(
        panelState.orderType,
        'Unknown order type'
      );
  }

  if (errorText) {
    throw new Error(errorText);
  }
  return;
}

// TODO: Copy
export const REDUCE_ONLY_AND_TPSL_COMBINE_ERROR =
  'TP/SL cannot be combined with Reduce-Only';

export function tpslChangeHandler(
  check: boolean,
  {
    walletAddress,
    panelState,
    panelDispatch,
    calculatedInfo,
  }: {
    walletAddress: string | undefined;
    panelState: PanelState;
    panelDispatch: (act: IAction) => void;
    calculatedInfo: BuySellPanelCalculatedInfo;
  }
) {
  if (!check) {
    panelDispatch({ type: 'setConditionalTpSl', tpsl: undefined });
    return;
  }

  try {
    if (!walletAddress) {
      throw new Error('Unlock your wallet to set TP/SL');
    }
    if (panelState.reduceOnly) {
      throw new Error(REDUCE_ONLY_AND_TPSL_COMBINE_ERROR);
    }
    validateTPSLOrThrow({ panelState, calculatedInfo });
  } catch (error) {
    console.warn(error);
    displayBasicNotification(
      error?.message || 'Error',
      `form_buySellTPSLError_${Date.now()}`,
      'error'
    );
    return;
  }

  panelDispatch({ type: 'showConditionlTpSlModal', open: true });
}
